import { LineChart, Line, ResponsiveContainer } from 'recharts';
import type { SparklinePoint } from '../../types/dashboard';

interface SparklineProps {
  data: SparklinePoint[];
  color?: string;
  width?: number;
  height?: number;
}

export default function Sparkline({ data, color = '#6366f1', width = 120, height = 36 }: SparklineProps) {
  if (!data || data.length === 0) return null;
  return (
    <div style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
